import 'swiper/swiper.scss';

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';

import { fetchTagsIfNeeded } from '@lootboy/lib/actions/TagActions';

import { IFilter } from '~/interfaces/IFilter';
// @ts-ignore missing typings in lib
import { filterableTagsSelector, languageSelector } from '~/redux/selectors';

import FilterButton from './FilterButton';

import styles from './Filters.module.scss';

interface IFilters {
  visible: boolean;
}

const Filters: React.FC<IFilters> = ({ visible }) => {
  const dispatch = useDispatch();

  const filters: IFilter[] = useSelector(filterableTagsSelector);
  const language = useSelector(languageSelector);

  useEffect(() => {
    dispatch(fetchTagsIfNeeded());
  }, [dispatch, language]);

  return (
    <div className={styles.wrapper}>
      <Swiper
        className={classNames(styles.swiper, visible && styles.visible)}
        slidesPerView="auto"
        centerInsufficientSlides
      >
        {filters.filter(Boolean).map((filter) => (
          <SwiperSlide key={filter._id}>
            <FilterButton filter={filter} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Filters;
